import api from '@/lib/axios';

// ============================================
// PRODUCTOS
// ============================================
export const productosService = {
  async findAll(params?: { companyId?: string; search?: string; categoryId?: string; page?: number; limit?: number }) {
    const response = await api.get('/products', { params });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  async findByBarcode(barcode: string, companyId: string) {
    const response = await api.get(`/products/barcode/${barcode}`, { params: { companyId } });
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/products', data);
    return response.data;
  },

  async bulkCreate(items: any[]) {
    const response = await api.post('/products/bulk', { items });
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.patch(`/products/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  },
};

// ============================================
// CATEGORÍAS
// ============================================
export const categoriasService = {
  async findAll(companyId: string) {
    const response = await api.get('/categories', { params: { companyId } });
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/categories', data);
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.patch(`/categories/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/categories/${id}`);
    return response.data;
  },
};

// ============================================
// MARCAS
// ============================================
export const marcasService = {
  async findAll(companyId: string) {
    const response = await api.get('/brands', { params: { companyId } });
    return response.data;
  },

  async create(data: any) {
    const response = await api.post('/brands', data);
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.patch(`/brands/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/brands/${id}`);
    return response.data;
  },
};

// ============================================
// UNIDADES
// ============================================
export const unidadesService = {
  async findAll(companyId: string) {
    const response = await api.get('/units', { params: { companyId } });
    return response.data;
  },

  async create(data: { companyId: string; name: string; abbreviation: string; satUnitKey?: string }) {
    const response = await api.post('/units', data);
    return response.data;
  },

  async update(id: string, data: Partial<{ name: string; abbreviation: string; satUnitKey: string }>) {
    const response = await api.patch(`/units/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/units/${id}`);
    return response.data;
  },
};
